import React from "react";
import Selector from "./selector";

const Checkbox = (props) => {
  return <Selector className={"checkbox"} {...props} />;
};

export default Checkbox;
